import React from 'react';
import styled from 'styled-components';
import {wh, fontSize} from '../mixins';


const Button = styled.button`
  ${wh('90%', 'auto')};
  min-height: 48px;
  max-width: 327px;
  background: ${props => props.customColor || '#256EB0'};
  transition: background .3s;
  color: #FFFFFF;
  ${fontSize(14)};
  line-height: 20px;
  font-weight: 400;
  padding: 14px 20px;
  border: none;
  border-radius: 24px;
  position: relative;
  z-index: ${props => props.zIndex ? props.zIndex : 'initial'};
  opacity: ${({inactive,disabled}) => (inactive || disabled) ? '0.6' : '1'};
  
  ${props => props.mobileOnly ? '@media screen and (min-width: 768px) {display: none;}' : null};
  
  &:focus {
    outline: none;
  }
  
  &:hover {
    background: ${props => (props.inactive || props.disabled) ? (props.customColor || '#256EB0') : (props.customHover || '#195993')};
  }
  
  &:active {
    background: ${props => props.customActive || '#145086'};
  }
  
  
`;

const UIButton = ({onClick, children, disabled, mobileOnly, customColor, customHover, customActive, zIndex, inactive, customId}) => {
    return (<Button mobileOnly={mobileOnly}
                    onClick={onClick}
                    disabled={disabled}
                    customColor={customColor}
                    customHover={customHover}
                    customActive={customActive}
                    zIndex={zIndex}
                    inactive={inactive}
                    id={customId || 'continue-button'}
    >{children}</Button>)
};

export default UIButton;